import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6db1c09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("不是")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("填空")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("判断")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("多选")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("添加")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "选项管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          style: {"margin-top":"10px"},
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'required')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.required == 0 ? '否' : '是'), 1))
              : _createCommentVNode("", true),
            (column.key === 'type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.type == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "填空"))
                    : _createCommentVNode("", true),
                  (record.type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, "选择"))
                    : _createCommentVNode("", true),
                  (record.type == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "判断"))
                    : _createCommentVNode("", true),
                  (record.type == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "多选"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'xuanxiang')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.options, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    style: {"margin-right":"10px"}
                  }, _toDisplayString(item.value), 1))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "删除该数据?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubmit('formRef'))),
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: _ctx.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "标签名称",
              name: "label"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.label,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.label) = $event)),
                  placeholder: "请输入标签名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "关键字",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入关键字"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否必填",
              name: "required"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.required,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.required) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "类型",
              name: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.type,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.type) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 4 }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "标签值" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.options, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_component_a_input, {
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                      placeholder: "请输入标签值",
                      style: {"width":"90%","margin-bottom":"10px"}
                    }, null, 8, ["value", "onUpdate:value"]),
                    _createVNode(_component_MinusCircleOutlined, {
                      onClick: ($event: any) => (_ctx.removeSight(index)),
                      style: {"margin-left":"20px"}
                    }, null, 8, ["onClick"])
                  ]))
                }), 128)),
                _createVNode(_component_a_button, {
                  type: "dashed",
                  style: {"width":"100%"},
                  onClick: _ctx.addDomain
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}